module.exports = __webpack_public_path__ + "static/img/y.14512d22.jpg";